import Api from '@/ultils/api-base'

export default {
   /**
    * Logs in a user by sending their credentials to the API.
    *
    * @param {Object} body - The login credentials.
    * @param {string} body.username - The username of the user.
    * @param {string} body.password - The password of the user.
    *
    * @returns {Promise<Object>} - A promise that resolves to the response object.
    * @property {string} [errorMessage] - An error message if the login fails.
    * @property {string} token - A token for the authenticated session.
    * @property {string} username - The username of the authenticated user.
    * @property {string} sessionId - The session ID of the authenticated session.
    */
   login(body) {
      return Api('POST', 'login', body)
   },
   getListWebGame(body) {
      return Api('POST', 'wsGetListWebGame', body)
   },
   getListBanners(body) {
      return Api('POST', 'wsGetHotNews', body)
   },
   getUserInfo(body) {
      return Api('POST', 'wsGetSubMainInfo', body)
   },
   getRank(body) {
      return Api('POST', 'wsLoyaltyGetAccountRankInfo', body)
   },
   getAvailableUpoint(body) {
      return Api('POST', 'wsLoyaltyGetAccountPointInfo', body)
   },
   getInfoCust(body) {
      return Api('POST', 'wsGetInfoCust', body)
   },
   getListFtthAccountInfo(body) {
      return Api('POST', 'wsGetListFtthAccountInfo', body)
   },
   demoUnipay(body) {
      return Api('POST', 'wsGetListFtthAccountInfo', body)
   },
   getRegInfoSub(body) {
      return Api('POST', 'wsRegInfoSub', body)
   },
   getParamConfig(body) {
      return Api('POST', 'wsGetParamConfig', body)
   },
   GetNoticeWebview(body) {
      return Api('POST', 'wsGetNoticeWebview', body)
   },
   GetSubAccountInfo(body) {
      return Api('POST', 'wsGetSubAccountInfo', body)
   },
   GetCurrentUsedSubServices(body) {
      return Api('POST', 'wsGetCurrentUsedSubServices', body)
   },
   GetServiceBestSeller(body) {
      return Api('POST', 'wsGetServiceBestSeller', body)
   },
   GetBannerWebview(body) {
      return Api('POST', 'wsGetBannerWebview', body)
   },
   GetLaoAppStatus(body) {
      return Api('POST', 'wsGetLaoAppStatus', body)
   },
   UpdateAvatar(body) {
      return Api('POST', 'wsUpdateAvatar', body)
   },

   wsChangeESim(body) {
      return Api('POST', 'wsChangeESim', body)
   },

   wsUploadImageEkyc(body) {
      return Api('POST', 'wsUploadImageEkyc', body)
   },

   GetNoteRoaming(body) {
      return Api('POST', 'ptg_getListAppParams', body)
   },

   wsGetRequestChangeSim(body) {
      return Api('POST', 'wsGetRequestChangeSim', body)
   },

   ptg_getAllQuestionSupport(body) {
      return Api('POST', 'ptg_getAllQuestionSupport', body)
   },

   //  form after sale
   wsGetOrderAfterSale(body) {
      return Api('POST', 'wsGetOrderAfterSale', body)
   },
   wsGetInfoCustV2(body) {
      return Api('POST', 'wsGetInfoCustV2', body)
   },
   wsExportPdfAfterSale(body) {
      return Api('POST', 'wsExportPdfAfterSale', body)
   },
   wsCreateRequestOpenRoaming(body) {
      return Api('POST', 'wsCreateRequestOpenRoaming', body)
   },
   wsCreateRequestAfterSale(body) {
      return Api('POST', 'wsCreateRequestAfterSale', body)
   },
   wsCreateOrderAfterSaleChangeInfo(body) {
      return Api('POST', 'wsCreateOrderAfterSaleChangeInfo', body)
   },
   wsGetReasonAfterSale(body) {
      return Api('POST', 'wsGetReasonAfterSale', body)
   },
    wsImportPdfAfterSale(body) {
      return Api('POST', 'wsImportPdfAfterSale', body)
   },
}
